import { Button, Flex, Grid, SelectField, TextField } from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const FAKE_FARMS = [
  { id: "farm-0001", name: "Finca Las Palmas" },
  { id: "farm-0002", name: "Finca El Roble" },
  { id: "farm-0003", name: "Finca La Esperanza" },
  { id: "farm-0004", name: "Finca San José" },
  { id: "farm-0005", name: "Finca Santa Rita" },
];

const WarehouseForm = ({ onSubmit, type = "create", initialValues = {} }) => {
  const defaultState = {
    farmId: "",
    warehouseNumber: "",
    customName: "",
    sizeM2: "",
    location: "",
    storageZones: "",
    shelves: "",
    createdAt: "",
  };

  const [form, setForm] = useState({ ...defaultState, ...initialValues });

  useEffect(() => {
    setForm({ ...defaultState, ...initialValues });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const onSubmitForm = () => {
    // deliver raw form (no normalization)
    onSubmit && onSubmit(form);
  };

  return (
    <Grid rowGap="15px" columnGap="15px" padding="20px">
      <Grid gap="15px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <SelectField
          name="farmId"
          label={strings.fields.farmId.label}
          value={form.farmId || ""}
          onChange={(e) => setForm({ ...form, farmId: e.target.value })}
        >
          <option value="">--</option>
          {FAKE_FARMS.map((f) => (
            <option key={f.id} value={f.id}>
              {f.name}
            </option>
          ))}
        </SelectField>

        <TextField
          name="warehouseNumber"
          label={strings.fields.warehouseNumber.label}
          value={form.warehouseNumber || ""}
          onChange={(e) => setForm({ ...form, warehouseNumber: e.target.value })}
        />
      </Grid>

      <TextField
        name="customName"
        label={strings.fields.customName.label}
        value={form.customName || ""}
        onChange={(e) => setForm({ ...form, customName: e.target.value })}
      />

      <Grid gap="15px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField
          name="sizeM2"
          label={strings.fields.sizeM2.label}
          value={form.sizeM2 || ""}
          onChange={(e) => setForm({ ...form, sizeM2: e.target.value })}
        />
        <TextField
          name="location"
          label={strings.fields.location.label}
          value={typeof form.location === "string" ? form.location : JSON.stringify(form.location)}
          onChange={(e) => setForm({ ...form, location: e.target.value })}
        />
      </Grid>

      <TextField
        name="storageZones"
        label={strings.fields.storageZones.label}
        placeholder="Zona A, Zona B"
        value={Array.isArray(form.storageZones) ? form.storageZones.join(", ") : form.storageZones || ""}
        onChange={(e) => setForm({ ...form, storageZones: e.target.value })}
      />

      <Flex justifyContent="end">
        <Button children={strings.fields.buttons.reset} onClick={() => setForm(defaultState)} />
        <Button children={type === "create" ? strings.fields.buttons.create : strings.fields.buttons.save} onClick={onSubmitForm} variation="primary" />
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      farmId: { label: "Finca" },
      warehouseNumber: { label: "Número de Almacén" },
      customName: { label: "Nombre" },
      sizeM2: { label: "Tamaño (m²)" },
      location: { label: "Ubicación / Punto clave" },
      storageZones: { label: "Zonas de Almacenamiento" },
      createdAt: { label: "Fecha de creación" },
      buttons: { create: "Crear", save: "Guardar", reset: "Restablecer" },
    },
  },
});

export default WarehouseForm;
